import styled from 'styled-components';

export default styled.div`
  transform: translateX(50%);
  position: absolute;
  width: 1.2rem;
  height: 1.2rem;
  top: -0.3rem;
  right: 0;
  background: #fff;
  box-shadow: 0px 3px 6px rgba(39, 39, 39, 1)19;
  border-radius: 0.6rem;

  ${props =>
    props.isLive &&
    `
    &::after {
      content: '';
      position: absolute;
      width: 0.6rem;
      height: 0.6rem;
      top: 0.3rem;
      left: 0.3rem;
      border-radius: 0.3rem;
      background: #FF6256;
    }
  `}
`;
